import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {paywallMessages, PaywallWarnError, responseConfig} from '@modules/paywall/services/paywallWarnService/paywallWarnConfig';

@Injectable({
  providedIn: 'root'
})

export class PaywallWarnService {

  constructor() { }

  private _updateMessageAndOpen$ = new Subject<string>();
  get updateMessageAndOpen$():Observable<string>{
    return this._updateMessageAndOpen$.asObservable();
  }

  processResponse(response:responseConfig) {
    if (!response.warning && !response.error){
      return;
    }
    const {messageCode, property} = this.getMessageCode(response);
    if(!messageCode){
      return;
    }
    let message:string = paywallMessages.get(messageCode);
    if (message){
      this._updateMessageAndOpen$.next(this.getProcessedMessage(message, response[property]));
    }
  }

  private getMessageCode(response):{messageCode: string, property: string} {
    if (response.error && !response.success){
     return {messageCode: response.error.code, property: 'error'};
    }
    if (response.warning){
      return {messageCode: response.warning.code, property: 'warning'};
    }
    return null;
  }

  private getProcessedMessage(message:string, warnError:PaywallWarnError):string{
    return message.replace(/\[WARNING_COUNT]/g, (warnError.data.maxObjectsCount - warnError.data.warningObjectsCount1).toString())
      .replace(/\[WARNING_MAX_COUNT]/g, warnError.data.maxObjectsCount.toString())
      .replace(/\[ERROR_MAX_COUNT]/g, warnError.data.maxObjectsCount.toString())
      .replace(/\[FORMATTED_AMOUNT]/g, warnError.data.formattedAmount.toString());
  }
}
